import React from 'react'
import { useDispatch } from 'react-redux';
import { DeleteCarUnderBrand } from '../actions';

const DeleteModal = ({ID}) => {
    console.log("deleteIdasdsadasd", ID);

    const dispatch = useDispatch()

    const onDeleteHandler = () => {
        dispatch(DeleteCarUnderBrand(ID))
    }
  return (
    <div className="modal fade" id="deleteCarModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
            <div className="modal-body">
            <h4 className="modal-title" id="deleteCarModal">Are you Really want to Delete?</h4>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">No</button>
                <button type="button" className="btn btn-danger" onClick={onDeleteHandler}>Yes</button>
            </div>
            </div>
        </div>
    </div>
  )
}

export default DeleteModal